// Types
export { AuthProviderOptions } from "./types";
export type {} from "./types"; // Ensure NextAuth module augmentation is loaded

// Auth errors
export {
  getAuthErrorMessage,
  getSignInErrorMessage,
  applySignInError,
} from "./auth-errors";

// Native preferences (Capacitor)
export {
  getNativePreference,
  setNativePreference,
  removeNativePreference,
} from "./native-preferences";

// Email verification
export {
  normalizeEmail,
  verifySignupToken,
  createVerificationToken,
  VerificationError,
} from "./email-verification";
export type { VerifySignupTokenResult } from "./email-verification";

// Token utilities
export { isTokenExpired, hasFirebaseUserId } from "./token-utils";

// Services
export { authenticateWithDatabaseApi } from "./services/auth";
export {
  enqueueDripCampaign,
  sendMockRegistrationEmail,
} from "./services/drip-campaign";

// Contact support
export { openContactSupport } from "./contact-support";

// Axios clients
export {
  nextApiClient,
  curriculumApiClient,
  curriculumApiV2Client,
  firebaseCurriculumApiClient,
  firebaseCurriculumApiV2Client,
  medlyBackendApiClient,
  medlyBackendPublicApiClient,
  getFirebaseAuthReady,
  getCachedCurriculumV2Token,
  getCurriculumV2BaseUrl,
} from "./axios-helper";

// Token refresh helpers
export { performTokenRefresh } from "./token-refresh";
export type { PerformTokenRefreshOptions } from "./token-refresh";

// API error observability
export {
  captureApiError,
  classifyAxiosError,
  CRITICAL_ERROR_TAG,
  REQUEST_ID_HEADER,
} from "./captureApiError";
export type { ApiErrorKind } from "./captureApiError";
